module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper-box"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.outputSize,
      "outputType": _vm.option.outputType,
      "info": _vm.option.info,
      "canScale": _vm.option.canScale,
      "autoCrop": _vm.option.autoCrop,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "full": _vm.option.full,
      "fixedBox": _vm.option.fixedBox,
      "canMove": _vm.option.canMove,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "centerBox": _vm.option.centerBox,
      "height": _vm.option.height,
      "infoTrue": _vm.option.infoTrue,
      "maxImgSize": _vm.option.maxImgSize,
      "enlarge": _vm.option.enlarge,
      "mode": _vm.option.mode
    },
    on: {
      "realTime": _vm.realTime,
      "imgLoad": _vm.imgLoad
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-btn"
  }, [_c('div', {
    staticClass: "scope-btn"
  }, [_c('label', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "0.3rem"
    },
    attrs: {
      "for": "uploads"
    }
  }, [_vm._v("选择图片")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0 0 0 0)"
    },
    attrs: {
      "type": "file",
      "id": "uploads",
      "accept": "image/png, image/jpeg, image/gif, image/jpg"
    },
    on: {
      "change": function($event) {
        return _vm.selectImg($event)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "0.05rem"
    },
    attrs: {
      "size": "mini",
      "type": "danger",
      "plain": "",
      "icon": "el-icon-zoom-in"
    },
    on: {
      "click": function($event) {
        return _vm.changeScale(1)
      }
    }
  }, [_vm._v("放大")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "0.05rem",
      "margin-left": "0.1rem"
    },
    attrs: {
      "size": "mini",
      "type": "danger",
      "plain": "",
      "icon": "el-icon-zoom-out"
    },
    on: {
      "click": function($event) {
        return _vm.changeScale(-1)
      }
    }
  }, [_vm._v("缩小")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "0.05rem",
      "margin-left": "0.1rem"
    },
    attrs: {
      "size": "mini",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.rotateLeft
    }
  }, [_vm._v("↺ 左旋转")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "0.05rem",
      "margin-left": "0.1rem"
    },
    attrs: {
      "size": "mini",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.rotateRight
    }
  }, [_vm._v("↻ 右旋转")])], 1), _vm._v(" "), _c('div', {
    staticClass: "upload-btn"
  }, [_c('label', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.uploadImg('blob')
      }
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63100834","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CropperImage.vue
// module id = 2436
// module chunks = 0